import axios from "axios";
import { API_URL, PUB_URL, PUB_API_URL, PUB_API_URL_FLEET } from "./constants";

axios.defaults.withCredentials = true;

export const LOGOUT_API = async () =>
  await axios.post(`${API_URL}/logout`);

export const GET_PROFILE_API = async () =>
  await axios.get(`${API_URL}/company-infos`);
export const GET_COUNTRIES_API = async () =>
  await axios.get(`${PUB_URL}/countries?multiDriver=true`);
export const GET_MANAGMENT_API = async (body) =>
  await axios.post(`${API_URL}/performances`, body);
export const GET_DRIVERS_API = async () =>
  await axios.get(`${API_URL}/drivers`);
export const GET_VEHICLES_API = async () =>
  await axios.get(`${API_URL}/vehicles`);
export const GET_TRIPS_API = async (filters) =>
  await axios.get(`${API_URL}/trips`, { params: filters });

export const GET_DRIVERS_BALANCE_API = async (filters) =>
  await axios.get(`${API_URL}/fleet-balance`, { params: filters });
export const GET_FLEET_BALANCE_API = async () =>
  await axios.get(`${API_URL}/total-balance`);

export const GET_DRIVERS_REVENUES_API = async (filters) =>
  await axios.get(`${API_URL}/drivers-earning-list`, {
    params: filters,
  });
export const GET_FLEET_REVENUES_API = async (filters) =>
  await axios.get(`${API_URL}/total-drivers-earning`, { params: filters });

export const GET_TRIP_API = async (id) =>
  await axios.get(`${API_URL}/trips/${id}`);
export const GET_LEVELPATH_API = async (body) =>
  await axios.post(`${PUB_API_URL}/public/sublevels`, body);
export const GET_MODELS_API = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/models`, body);
export const GET_EARNINGS_API = async (body) =>
  await axios.post(`${API_URL}/earnings`, body);
export const POST_DRIVER_API = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/driver`, body);
export const POST_VEHICLE_API = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/vehicle`, body);
export const GET_DRIVER_API = async (idDriver) =>
  await axios.get(`${PUB_API_URL_FLEET}/${idDriver}/details`);
export const PUT_AFFECT_CAR_API = async (body) =>
  await axios.put(`${PUB_API_URL_FLEET}/affect-car`, body);
export const DELETE_CAR_API = async (vehicleId) =>
  await axios.delete(`${PUB_API_URL_FLEET}/delete-car/${vehicleId}`);

export const REQUEST_DELETE_API = async (driverId) =>
  await axios.put(`${PUB_API_URL_FLEET}/${driverId}/request-delete`, driverId);
export const GET_PAYMENTS_API = async (body) =>
  await axios.post(`${API_URL}/company-payment`, body);
export const GET_VEHICLE_API = async (vehicleId) =>
  await axios.get(`${API_URL}/vehicle/${vehicleId}`);
export const EDIT_VEHICLE_API = async (body, vehicleId) =>
  await axios.put(`${API_URL}/vehicle/${vehicleId}`, body);
export const EDIT_DRIVER_API = async (body, driverId) =>
  await axios.put(`${API_URL}/driver/${driverId}`, body);
export const PUT_RETRACT_CAR_API = async (body) =>
  await axios.put(`${PUB_API_URL_FLEET}/retract-car`, body);
export const GET_LIST_METHOD_PAYMENT_API = async () =>
  await axios({
    method: "post",
    url: `${API_URL}/epay/methods/v2/all`,
  });
export const POST_PAY_COMMISSION_API = async (body) =>
  await axios.post(`${API_URL}/epay/payment/pay`, body);
export const POST_CHECK_PAY_API = async (body) =>
  await axios.post(`${API_URL}/epay/payment/check`, body);

export const GET_DRIVERS = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/drivers/map`, body);

export const GET_SERVICES = async () =>
  await axios.get(`${PUB_API_URL_FLEET}/services`);

export const GET_DRIVERS_MAP = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/drivers/map`, body);

export const GET_DRIVER_DOCUMENTS = async (driverId) =>
  await axios.get(`${PUB_API_URL_FLEET}/driver/${driverId}/documents`);

export const SUBMIT_DRIVER_DOCUMENTS = async (driverId, body) =>
  await axios.post(
    `${PUB_API_URL_FLEET}/driver/${driverId}/upload-documents`,
    body
  );
